import styled from 'styled-components'

const ImageListWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 999;
  background: ${({ theme }) => theme.app.background};
  padding-bottom: ${({ $isMobile }) =>
    $isMobile ? 'calc(86px + env(safe-area-inset-bottom, 0px))' : '0px'};
`

const ImageListContainer = styled.div`
  align-self: flex-start;
  top: 0;
  z-index: 100;
  background: ${({ theme }) => theme.app.background};
  padding: 20px 0px;
  width: fit-content;
`;

export { ImageListWrapper, ImageListContainer }